export const base = '/appeals/:appealId';